import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { extractBackendErrorDetail, HttpErrorsService } from '../services/http-errors.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {

  const httpErrorsService = inject(HttpErrorsService);

   return next(req).pipe(
    catchError((error) => {
      // El authInterceptor administra 401. El resto, incluido status 0,
      // se notifica aquí para mantener una sola fuente de mensajes.
      if (error instanceof HttpErrorResponse && error.status !== 401) {
        const detail = extractBackendErrorDetail(error);
        httpErrorsService.handleError(error.status, error.message, detail);
      }
      // Retorna el error para que pueda manejarse posteriormente si es necesario
      return throwError(() => error);
    })
  );
};
